import { ProcessHeader } from "./Process.styled";
import { ProcessAnimation } from "./ProcessAnimation";

interface ProcessProps {
  title: string;
  subtitle: string;
  content: Array<{
    header: string;
    body: string;
  }>;
}

export const Process = ({ title, subtitle, content }: ProcessProps) => {
  return (
    <>
      <ProcessHeader>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </ProcessHeader>
      <ProcessAnimation content={content} />
    </>
  );
};
